import React from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';

const PhotoCard = ({ photo }) => {

    const { id, image, category, owner, camera, time } = photo

    const user = useSelector((state) => state.user.loggedin)
    const history = useHistory()
    const handleDetails = () => {
        history.push(`/photo/${id}`)
    }

    return(
        <div className="photo-card">
            <img src={image} alt="img"  />
            <div className="content center">
            <span><i className="fas fa-user-circle"></i> {owner.username}</span>
                <h3><i className="fas fa-camera-retro"></i> {camera} </h3>
                <h3><i className="fas fa-bars"></i> {category}</h3>
                <h4><i className="far fa-calendar-alt"></i> {time}</h4>
          {user ? <button id="view-more-btn" onClick={handleDetails}>Camera Setting</button>:null}
            </div>
        </div>
    )
}

export default PhotoCard;